import { useState, useEffect } from "react";
import { MdClear } from "react-icons/md";

export interface SearchBarProps {
  onSearch: (value: string) => void;
  placeholder?: string;
  loading?: boolean;
  debounceMs?: number;
}

const SearchBar: React.FC<SearchBarProps> = ({
  onSearch,
  placeholder = "Search...",
  loading = false,
  debounceMs = 500,
}) => {
  const [filter, setFilter] = useState("");
  const [debounceTimeout, setDebounceTimeout] = useState<number | null>(null);

  useEffect(() => {
    if (debounceTimeout) window.clearTimeout(debounceTimeout);

    const timeout = window.setTimeout(() => {
      onSearch(filter);
    }, debounceMs);

    setDebounceTimeout(timeout);

    return () => window.clearTimeout(timeout);
  }, [filter, onSearch, debounceMs]);

  const handleClear = () => {
    setFilter("");
    onSearch("");
  };

  const handleSearchClick = () => {
    onSearch(filter);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") handleSearchClick();
  };

  return (
    <div className="w-full relative max-w-md">
  <input
    type="text"
    value={filter}
    onChange={(e) => setFilter(e.target.value)}
    onKeyDown={handleKeyDown}
    placeholder={placeholder}
    className="
      w-full pl-4 pr-20 py-2 text-md rounded-full
      border border-green-700 focus:outline-none
      bg-white text-gray-900 placeholder:text-gray-500
      dark:bg-gray-800 dark:text-gray-100 dark:border-green-500
      dark:placeholder:text-gray-400
      transition
    "
  />

  {filter && (
    <button
      onClick={handleClear}
      className="
        absolute right-10 top-1/2 -translate-y-1/2
        text-red-600 hover:text-red-700
        dark:text-red-400 dark:hover:text-red-300
        transition
      "
    >
      <MdClear size={18} />
    </button>
  )}

  <button
    onClick={handleSearchClick}
    className="
      absolute right-1 top-1/2 -translate-y-1/2 
      px-3 py-1 rounded-full text-green-900
      hover:bg-green-200
      dark:text-green-200 dark:hover:bg-green-700
      transition
    "
  >
    {loading ? "..." : "🔍"}
  </button>
</div>
  );
};

export default SearchBar;